<h1 class="page-title">Speech Sentiment Analysis  </h1>
<div class="top-summary">
<p>To use the app, press the microphone icon, speak the sentence you want to analyze into the microphone, and then press the microphone icon again to pause the recording and see the analysis results. 
  If the results don't appear, please try refreshing the browser or test the model in <a href="https://huggingface.co/iamsuman/finetuned-sentiment-distilbert-base-uncased-model-3000" target="_blank">Hugging Face</a>.
</p>
  </div>
<div class="speech-container">
  <section>
    <mat-card *ngIf="errorMessage$| async as errorMessage" class="notification">{{errorMessage}}</mat-card>
  </section>
  <section>
   
    <mat-form-field>
      <mat-label>Select your language</mat-label>
      
      <mat-select [(value)]="currentLanguage">
        <mat-option *ngFor="let language of languages" [value]="language" (click)="selectLanguage(language)">
          {{language}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </section>
  <section>
    <button mat-fab *ngIf="listening$ | async; else mic" (click)="stop()">
      <mat-icon class="soundwave">mic</mat-icon>
    </button>
    <ng-template #mic>
      <button mat-fab (click)="start()">
        <mat-icon>mic</mat-icon>
      </button>
    </ng-template>
  </section>
<section *ngIf="transcript$ | async">
  <mat-card class="notification mat-elevation-z4">{{transcript$ | async}}</mat-card>
</section>
<section>
  <mat-form-field class="speech-result-width">
    <textarea matInput [value]="totalTranscript || ''" placeholder="Speech Input Sentiment Result" rows="3" disabled="true"></textarea>
  </mat-form-field>
</section>
</div>

<div class="top-summary">
  <p>
  This project utilizes a finetune model called <a href="https://huggingface.co/iamsuman/finetuned-sentiment-distilbert-base-uncased-model-3000" target="_blank">finetuned-sentiment-distilbert-base-uncased-model-3000</a> for Sentiment Analysis from Hugging Face. 
  To build this model, I started with the <a href="https://huggingface.co/datasets/imdb" target="_blank">IMDb dataset</a>.  This movie reviews dataset has three splits: <strong class="highlight">train, test and unsupervised</strong>. I  used only the train and test splits, which contain 25000 data points each. 
  However, since it is too many for our test, I took a sample of each split.
</p>
<p>
  I loaded the <strong class="highlight">tokenizer and data collator</strong>, where the tokenizer is responsible for tokenizing the text and converting it to <strong class="highlight">input_ids</strong>, and the data collator ensures that all data samples have the same length.
  To create a model, I started with the <a href="https://huggingface.co/docs/transformers/model_doc/auto#transformers.AutoModelForSequenceClassification" target="_blank">AutoModelForSequenceClassification </a> and chose the 
  <a href="https://huggingface.co/distilbert-base-uncased" target="_blank">DistilBERT base model (uncased)</a> as it is a small model that can be finetuned quickly. The AutoModelForSequenceClassification adds a classification head on top of the pretrained DistilBERT base model (uncased).
</p>
<p>
  I measured the model performance using <a href="https://huggingface.co/spaces/evaluate-metric/f1" target="_blank">f1</a> and <a href="https://huggingface.co/spaces/evaluate-metric/accuracy" target="_blank">accuracy</a> and trained the model for <strong class="highlight">3</strong> epochs, which resulted in an accuracy of over <strong class="highlight">87%</strong>. 
  After that, I fine-tuned the model using different regularization techniques and used <strong class="highlight">Adam</strong> as an optimizer with a learning rate of <strong class="highlight">0.001</strong>. 
  I evaluated the model using various evaluation metrics such as <strong class="highlight">accuracy, f1, precision, and recall</strong>. 
  Finally, I deployed the model to Hugging Face and consumed the API through the Sentiment Analysis web application written in Angular.
</p>
  <p> For more information about the model buliding process, please visit 
    <a href="https://colab.research.google.com/drive/1Ohn8qxB_204aHTyFDpAMbURzVKYxbdFP?usp=sharing" target="_blank">here</a>. Additionally, if you are interested in model, feel free to check it out on 
    my <a href="https://huggingface.co/iamsuman/finetuned-sentiment-distilbert-base-uncased-model-3000" target="_blank">Hugging Face</a>.</p>
</div>

<div class="steps-container">
  <small class="steps-description">
    <p><strong class="highlight">Resources</strong></p>
    <ul class="steps">
      <li>- <a href="https://huggingface.co/blog/sentiment-analysis-python" target="_blank">Getting Started with Sentiment Analysis using Python</a></li>
      <li>- <a href="https://medium.com/technology-hits/customize-your-sentiment-analysis-application-in-huggingface-8883ffe041c7" target="_blank">Customize Your Sentiment Analysis Application in Hugging Face.</a></li>
      <li>- <a href="https://huggingface.co/blog/sentiment-analysis-python" target="_blank">Effortless Sentiment Analysis with Hugging Face Transformers: A Beginner’s Guide</a></li>
      <li>- <a href="https://luixaviles.com/2020/07/build-your-first-voice-driven-web-app/" target="_blank">Build Your First Voice-Driven Web Application</a></li>
    </ul>
  </small>
</div>
